import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Container } from 'reactstrap';
import { H3, P, Btn } from '../../../AbstractElements';
import { BACK_TO_HOME_PAGE, Error3Head, ErrorPageContent } from '../../../Constant';
import { Error3 } from '../../../Data/Page/Svg';

const Error_page3 = () => {
  return (
    <div className='page-wrapper compact-wrapper' id='pageWrapper'>
      <div className='error-wrapper'>
        <Container>
          <div className='svg-wrraper error3'>
            <Error3 />
          </div>
          <Col md='8' className='offset-md-2'>
            <H3>{Error3Head}</H3>
            <P className='sub-content'>{ErrorPageContent}</P>
            <Link to={`${process.env.PUBLIC_URL}`}>
              <Btn color='primary'>{BACK_TO_HOME_PAGE}</Btn>
            </Link>
          </Col>
        </Container>
      </div>
    </div>
  );
};

export default Error_page3;
